export default function TermsConditions() {
  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-4xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <h1 className="font-heading font-black text-3xl md:text-4xl tracking-tight uppercase mb-8">
          Terms and Conditions
        </h1>

        <div className="prose prose-lg max-w-none space-y-6 text-foreground/90">
          <p>
            All of our items are aftermarket and may differ from decorations that come on vehicles as standard.
          </p>
          <p>
            The decals and badges on this website are not official (unless otherwise stated) and are only meant as compatible replacements or decorative items as stated in their descriptions.
          </p>
          <p>
            Our parts are designed to be used as replacements for old and damaged parts where originals are no longer available.
          </p>
          <p>
            No guarantees are made to the colour and finish in comparison to OEM parts.
          </p>
          <p className="font-semibold">
            Please make an enquiry before ordering if you have specific needs.
          </p>

          <hr className="my-8 border-border" />

          <h2 className="font-heading font-bold text-2xl tracking-tight uppercase mt-12 mb-6">
            Privacy Policy
          </h2>

          <p>
            This privacy policy has been compiled to better serve those who are concerned with how their 'Personally Identifiable Information' (PII) is being used online. PII, as described in UK privacy law and information security, is information that can be used on its own or with other information to identify, contact, or locate a single person, or to identify an individual in context. Please read our privacy policy carefully to get a clear understanding of how we collect, use, protect or otherwise handle your Personally Identifiable Information in accordance with our website.
          </p>

          <h3 className="font-heading font-bold text-xl tracking-tight mt-8 mb-4">
            What personal information do we collect from the people that visit our blog, website or app?
          </h3>
          <p>
            When ordering or registering on our site, as appropriate, you may be asked to enter your name, email address or other details to help you with your experience.
          </p>

          <h3 className="font-heading font-bold text-xl tracking-tight mt-8 mb-4">
            When do we collect information?
          </h3>
          <p>
            We collect information from you when you register on our site, place an order, subscribe to a newsletter or enter information on our site.
          </p>

          <h3 className="font-heading font-bold text-xl tracking-tight mt-8 mb-4">
            How do we use your information?
          </h3>
          <p>
            We may use the information we collect from you when you register, make a purchase, sign up for our newsletter, respond to a survey or marketing communication, surf the website, or use certain other site features in the following ways:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>To personalize your experience and to allow us to deliver the type of content and product offerings in which you are most interested.</li>
            <li>To improve our website in order to better serve you.</li>
            <li>To allow us to better service you in responding to your customer service requests.</li>
            <li>To quickly process your transactions.</li>
          </ul>

          <h3 className="font-heading font-bold text-xl tracking-tight mt-8 mb-4">
            How do we protect your information?
          </h3>
          <p>
            Our website is scanned on a regular basis for security holes and known vulnerabilities in order to make your visit to our site as safe as possible.
          </p>
          <p>We use regular Malware Scanning.</p>
          <p>
            Your personal information is contained behind secured networks and is only accessible by a limited number of persons who have special access rights to such systems, and are required to keep the information confidential. In addition, all sensitive/credit information you supply is encrypted via Secure Socket Layer (SSL) technology.
          </p>
          <p>
            We implement a variety of security measures when a user places an order enters, submits, or accesses their information to maintain the safety of your personal information.
          </p>
          <p>
            All transactions are processed through a gateway provider and are not stored or processed on our servers.
          </p>

          <h3 className="font-heading font-bold text-xl tracking-tight mt-8 mb-4">
            Do we use 'cookies'?
          </h3>
          <p>We do not use cookies for tracking purposes.</p>
          <p>
            You can choose to have your computer warn you each time a cookie is being sent, or you can choose to turn off all cookies. You do this through your browser settings. Since browser is a little different, look at your browser's Help Menu to learn the correct way to modify your cookies.
          </p>
          <p>
            If you turn cookies off, some of the features that make your site experience more efficient may not function properly.
          </p>

          <h3 className="font-heading font-bold text-xl tracking-tight mt-8 mb-4">
            Third-party disclosure
          </h3>
          <p>
            We do not sell, trade, or otherwise transfer to outside parties your Personally Identifiable Information.
          </p>

          <h3 className="font-heading font-bold text-xl tracking-tight mt-8 mb-4">
            Third-party links
          </h3>
          <p>
            We do not include or offer third-party products or services on our website.
          </p>

          <h3 className="font-heading font-bold text-xl tracking-tight mt-8 mb-4">
            Google
          </h3>
          <p>
            Google's advertising requirements can be summed up by Google's Advertising Principles. They are put in place to provide a positive experience for users.{" "}
            <a 
              href="https://support.google.com/adwordspolicy/answer/1316548?hl=en" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-primary underline hover:no-underline"
            >
              https://support.google.com/adwordspolicy/answer/1316548?hl=en
            </a>
          </p>
          <p>
            We have not enabled Google AdSense on our site but we may do so in the future.
          </p>

          <p className="mt-6">We agree to the following:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Users can visit our site anonymously.</li>
            <li>Once this privacy policy is created, we will add a link to it on our home page or as a minimum, on the first significant page after entering our website.</li>
            <li>Our Privacy Policy link includes the word 'Privacy' and can easily be found on the page specified above.</li>
          </ul>

          <p className="mt-6">You will be notified of any Privacy Policy changes:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>On our Privacy Policy Page</li>
          </ul>

          <p className="mt-6">Can change your personal information:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>By logging in to your account</li>
          </ul>

          <h3 className="font-heading font-bold text-xl tracking-tight mt-8 mb-4">
            How does our site handle Do Not Track signals?
          </h3>
          <p>
            We honor Do Not Track signals and Do Not Track, plant cookies, or use advertising when a Do Not Track (DNT) browser mechanism is in place.
          </p>

          <h3 className="font-heading font-bold text-xl tracking-tight mt-8 mb-4">
            Does our site allow third-party behavioral tracking?
          </h3>
          <p>
            It's also important to note that we do not allow third-party behavioral tracking.
          </p>

          <h3 className="font-heading font-bold text-xl tracking-tight mt-8 mb-4">
            COPPA (Children Online Privacy Protection Act)
          </h3>
          <p>
            When it comes to the collection of personal information from children under the age of 13 years old, the Children's Online Privacy Protection Act (COPPA) puts parents in control. The Federal Trade Commission, consumer protection agency, enforces the COPPA Rule, which spells out what operators of websites and online services must do to protect children's privacy and safety online.
          </p>
          <p>
            We do not specifically market to children under the age of 13 years old.
          </p>
          <p>
            Do we let third-parties, including ad networks or plug-ins collect PII from children under 13?
          </p>

          <h3 className="font-heading font-bold text-xl tracking-tight mt-8 mb-4">
            Fair Information Practices
          </h3>
          <p>
            The Fair Information Practices Principles form the backbone of privacy law in the United States and the concepts they include have played a significant role in the development of data protection laws around the globe. Understanding the Fair Information Practice Principles and how they should be implemented is critical to comply with the various privacy laws that protect personal information.
          </p>
          <p>
            In order to be in line with Fair Information Practices we will take the following responsive action, should a data breach occur:
          </p>
          <p>We will notify you via email:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Within 7 business days</li>
          </ul>
          <p className="mt-4">
            We also agree to the Individual Redress Principle which requires that individuals have the right to legally pursue enforceable rights against data collectors and processors who fail to adhere to the law. This principle requires not only that individuals have enforceable rights against data users, but also that individuals have recourse to courts or government agencies to investigate and/or prosecute non-compliance by data processors.
          </p>

          <h3 className="font-heading font-bold text-xl tracking-tight mt-8 mb-4">
            CAN SPAM Act
          </h3>
          <p>
            The CAN-SPAM Act is a law that sets the rules for commercial email, establishes requirements for commercial messages, gives recipients the right to have emails stopped from being sent to them, and spells out tough penalties for violations.
          </p>
          <p>We collect your email address in order to:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Send information, respond to inquiries, and/or other requests or questions</li>
            <li>Process orders and to send information and updates pertaining to orders.</li>
            <li>Send you additional information related to your product and/or service</li>
          </ul>

          <p className="mt-6">To be in accordance with CANSPAM, we agree to the following:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Not use false or misleading subjects or email addresses.</li>
            <li>Identify the message as an advertisement in some reasonable way.</li>
            <li>Include the physical address of our business or site headquarters.</li>
            <li>Monitor third-party email marketing services for compliance, if one is used.</li>
            <li>Honor opt-out/unsubscribe requests quickly.</li>
            <li>Allow users to unsubscribe by using the link at the bottom of each email.</li>
          </ul>

          <p className="mt-6">
            If at any time you would like to unsubscribe from receiving future emails, you can email us at:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              <a href="mailto:sales@zengraphics.co.uk" className="text-primary underline hover:no-underline">
                sales@zengraphics.co.uk
              </a>
            </li>
          </ul>
          <p>and we will promptly remove you from ALL correspondence.</p>

          <hr className="my-8 border-border" />

          <h3 className="font-heading font-bold text-xl tracking-tight mt-8 mb-4">
            Contacting Us
          </h3>
          <p>
            If there are any questions regarding this privacy policy, you may contact us using the information below.
          </p>
          <p className="mt-4">
            <a href="mailto:ministripesuk@gmail.com" className="text-primary underline hover:no-underline">
              ministripesuk@gmail.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
